import { InAppMessageDelay } from "../delay/InAppMessageDelay"
import { InAppMessageDeliverResponse } from "../deliver/InAppMessageDeliverResponse"
import { InAppMessageScheduleRequest } from "./InAppMessageScheduleRequest"

type ScheduleResponseCode = "DELIVER" | "DELAY" | "IGNORE" | "EXCEPTION"

export class InAppMessageScheduleResponse {
  constructor(
    public readonly dispatchId: string,
    public readonly inAppMessageKey: number,
    public readonly code: ScheduleResponseCode,
    public readonly deliverResponse: InAppMessageDeliverResponse | null,
    public readonly delay: InAppMessageDelay | null
  ) {}

  /**
   * @override
   */
  toString(): String {
    return `InAppMessageScheduleResponse(dispatchId=${this.dispatchId}, inAppMessageKey=${this.inAppMessageKey}, code=${this.code})`
  }

  static of(
    request: InAppMessageScheduleRequest,
    code: ScheduleResponseCode,
    deliverResponse: InAppMessageDeliverResponse | null = null,
    delay: InAppMessageDelay | null = null
  ): InAppMessageScheduleResponse {
    return new InAppMessageScheduleResponse(
      request.schedule.dispatchId,
      request.schedule.inAppMessageKey,
      code,
      deliverResponse,
      delay
    )
  }
}
